import React from 'react'
import styled from 'styled-components'
import Header from '@oldscope/ui/components/Header'
import { PageFactory } from './Page'
import Features from '../components/Features'

const MyHeader = styled(Header)`
  && {
    ${({ importance }) =>
      ({
        h1: `
          text-align: center;
        `,
        h2: `
          text-align: center;
          padding-bottom: 15px;
          margin-bottom: 20px;
          margin-top: 30px;
          border-bottom: 2px solid #ddd;
          color: #666;  
        `,
      }[`h${importance}`])}
  }
`

const HomePageHeader = ({ level, children }) => (
  <MyHeader importance={level}>{children}</MyHeader>
)

const BasePost = PageFactory({
  renderers: {
    Features,
    heading: HomePageHeader,
  },
})

export default props => <BasePost {...props} which="home" />
